import { render, staticRenderFns } from "./rate-regions-table.vue?vue&type=template&id=45b8b175&scoped=true"
import script from "./rate-regions-table.vue?vue&type=script&lang=js"
export * from "./rate-regions-table.vue?vue&type=script&lang=js"
import style0 from "./rate-regions-table.vue?vue&type=style&index=0&id=45b8b175&prod&lang=scss&scoped=true"
import style1 from "./rate-regions-table.vue?vue&type=style&index=1&id=45b8b175&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b8b175",
  null
  
)

export default component.exports